/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Container from '@ba-ui-toolkit/container';
import Label from '@ba-ui-toolkit/label';
import { classnames as cx, propsUtils } from '@ba-ui-toolkit/utils';
import styles from './PropertyPanel.scss';

const propertyPanelClassName = styles.propertyPanelClassName.replace(/"/g, '');
const { sanitize } = propsUtils;

export default class PropertyPanel extends Component {
	static propTypes = {
		title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
		className: PropTypes.string,
		// children:
		// Tabs -> TabPanels -> PropertySections
		// PropertySections
		children: PropTypes.oneOfType([PropTypes.node, PropTypes.array]),
		buttons: PropTypes.oneOfType([PropTypes.node, PropTypes.array]),
		rtl: PropTypes.bool,
		isResizable: PropTypes.bool,
		style: PropTypes.object,
	};
	static defaultProps = {
		className: '',
		style: {},
		title: '',
	};
	render() {
		const { title, className, isResizable, children, buttons, style, ...others } = this.props;
		const titleSection = (
			<Label
				data-tid="ba-common-property-panel__title-section"
				className={`${propertyPanelClassName}__panelTitle`}
				label={title}
			/>
		);

		const childrenContent = (
			<Container data-tid="ba-common-property-panel__content-section">{children}</Container>
		);
		const buttonsSection = buttons ? (
			<Container
				data-tid="ba-common-property-panel__button-section"
				className={`${propertyPanelClassName}__buttonSection`}
			>
				{buttons}
			</Container>
		) : (
			''
		);
		const classNames = cx(propertyPanelClassName);

		return (
			<Container
				{...sanitize(others, PropertyPanel)}
				className={`${classNames} ${className}`}
				resizable={isResizable}
				style={style}
			>
				{titleSection}
				{childrenContent}
				{buttonsSection}
			</Container>
		);
	}
}
